import { Link, useParams } from 'react-router-dom';

import { Drawer } from './drawer';
import { useGetInconsistenciesByIds } from '@/api/queries/useGetInconsistenciesById';
import { Inconsistency } from '@/api/types/backend-dto-types';
import { Icon } from '@/new/components/icon';
import { InconsistencyCard } from '@/new/components/inconsistency/inconsistency-card';
import { Accordion } from '@/new/components/shadcn/accordion';
import { Button } from '@/new/components/shadcn/button';
import { useStore } from '@/store';

export function InconsistencyDrawer() {
  const { matterId, subsetId } = useParams();
  const { inconsistencyDrawer, closeInconsistencyDrawer } = useStore();

  const { data } = useGetInconsistenciesByIds({
    matterId: matterId ?? '',
    inconsistencyIds: inconsistencyDrawer.inconsistencyIds,
  });

  if (!matterId || !subsetId) return null;

  return (
    <Drawer isOpen={inconsistencyDrawer.isOpen} onClose={closeInconsistencyDrawer} hideCloseButton={true}>
      <div className="flex flex-col gap-5 py-5">
        <div className="mx-9 border-b pb-2">
          <div className="flex items-center justify-between gap-2">
            <h2 className="font-serif text-lg font-medium">Inconsistencies</h2>
            <Button asChild variant="ghost" size="icon" className="p-0 text-xs text-blue-500 hover:text-blue-700">
              <Link onClick={closeInconsistencyDrawer} to={`/matters/${matterId}/subsets/${subsetId}/inconsistencies`}>
                All Inconsistencies
                <Icon className="lucide--arrow-right" />
              </Link>
            </Button>
          </div>
          <p className="text-xs text-gray-500">This fact is involved in the following inconsistencies.</p>
        </div>
        <Accordion type="multiple" className="mx-5 flex flex-col gap-5 overflow-auto">
          {data?.map((inconsistency: Inconsistency) => (
            <InconsistencyCard key={inconsistency.id} inconsistency={inconsistency} inInconsistencyDrawer={true} />
          ))}
        </Accordion>
      </div>
    </Drawer>
  );
}
